// extracted by mini-css-extract-plugin
export default {"read":"styles_read__XXZVT","unread":"styles_unread__XFCZW"};